/**
 * NER-4488 fase 2 — Helpers puros de las plantillas de grupos de modificadores.
 */

import { getModifierTemplate } from '../data/modifierTemplates';
import { normalizeText } from './text';

/**
 * Convierte una plantilla en el estado del formulario de ModifiersPage.
 * `t` es la función de i18n; todas las opciones arrancan con precio extra 0.
 */
export function templateToGroup(templateOrId, t) {
  const template =
    typeof templateOrId === 'string' ? getModifierTemplate(templateOrId) : templateOrId;
  if (!template) return null;
  return {
    name: t(`modifierTemplates.${template.id}.name`),
    minSelect: template.minSelect,
    maxSelect: template.maxSelect,
    required: template.required,
    options: template.options.map((key) => ({
      name: t(`modifierTemplates.${template.id}.options.${key}`),
      price: 0,
    })),
  };
}

/**
 * ModifiersPage rechaza nombres duplicados: si ya existe un grupo con ese
 * nombre, devuelve "Nombre (2)", "Nombre (3)", etc.
 */
export function uniqueGroupName(name, existingGroups) {
  const taken = new Set((existingGroups || []).map((group) => normalizeText(group.name).trim()));
  const base = (name || '').trim();
  if (!taken.has(normalizeText(base))) return base;
  let counter = 2;
  while (taken.has(normalizeText(`${base} (${counter})`))) counter += 1;
  return `${base} (${counter})`;
}

/**
 * Resumen corto para la card de la plantilla: cuántas opciones y si es
 * obligatorio / cuántas puede elegir el cliente.
 */
export function describeSelection(template, t) {
  const { minSelect, maxSelect, required } = template;
  if (required && minSelect === 1 && maxSelect === 1) {
    return t('templates.chips.pickOne');
  }
  if (!required && minSelect === 0) {
    return t('templates.chips.optionalUpTo', { max: maxSelect });
  }
  return t('templates.chips.pickRange', { min: minSelect, max: maxSelect });
}
